import React from 'react';
import { styled } from '@mui/system';
import Link from '@mui/material/Link';

type RenovationVoiceImagePropsData = {
  src: string;
  alt: string;
  href: string | null;
  className: string;
};

const Image = styled('img')`
  width: 100%;
  height: auto;
  border-radius: 16px;
  margin: 0;

  @media (max-width: 767px) {
    border-radius: 6px;
  }

  @media (max-width: 600px) {
    width: 100%;
    height: auto;
  }
`;

export default function RenovationVoiceImage({
  src,
  alt,
  href = null,
  className = '',
}: RenovationVoiceImagePropsData): JSX.Element {
  return href ? (
    <Link href={href}>
      <Image src={src} alt={alt} className={className} />
    </Link>
  ) : (
    <Image src={src} alt={alt} className={className} />
  );
}
